export function Diamond1Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.575 10.612a1.963 1.963 0 000 2.776l7.037 7.037c.767.767 2.01.767 2.776 0l7.037-7.037a1.963 1.963 0 000-2.776l-7.037-7.037a1.963 1.963 0 00-2.776 0l-7.037 7.037zM5.015 12L12 18.985 18.985 12 12 5.016 5.016 12z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
